import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '../api-client.ts';
import type { CategoryDto, CreateCategoryDto } from '../types';

export const useCreateCategory = (projectUuid: string) => {
  const queryClient = useQueryClient();

  return useMutation<CategoryDto, Error, CreateCategoryDto>({
    mutationFn: (data) => apiClient.post(`/v1/projects/${projectUuid}/categories`, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['categories', projectUuid] });
    },
  });
};
